import script from "./ImageUploadBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageUploadBtn.vue?vue&type=script&setup=true&lang=js"

import "./ImageUploadBtn.vue?vue&type=style&index=0&id=d37fb0da&lang=css"

const __exports__ = script;

export default __exports__